"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_USAGE_POINTS = void 0;
/*
export const FILTER = 'FILTER';
export const SHOW_ACTIVE = 'SHOW_ACTIVE';
export const SHOW_PASSIVE = 'SHOW_PASSIVE';
*/

exports.ADD_USAGE_POINTS = 'ADD_USAGE_POINTS';